var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-content",
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c(
        "el-card",
        { staticClass: "card-totais box-card", attrs: { shadow: "always" } },
        [
          _c("h3", [
            _vm._v(
              _vm._s(_vm.setorWithCount.setor.codigo.replace(/_/g, " ")) +
                " - " +
                _vm._s(_vm.setorWithCount.setor.nome)
            )
          ]),
          _c("p", [
            _vm._v(
              "Quantidade de processos no setor: " +
                _vm._s(_vm.setorWithCount.qtdProcessos)
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7311bbcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7311bbcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/produtividade/components/CardSetorProdutividade.vue
// module id = null
// module chunks = 